var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3377 36.3125C20.2752 42.0156 21.5252 49.125 21.994 52.1719C22.4627 55.1406 23.0096 58.8125 23.244 60.1406C23.4784 61.5469 24.1034 62.7188 24.6502 62.7188C26.369 62.7188 30.8221 60.5312 32.4627 58.8906C35.3534 56 35.8221 55.1406 38.7909 47.5625C42.3065 38.6562 42.3065 38.6562 44.2596 52.875C45.1971 59.4375 45.9784 62.7188 46.6034 62.7188C47.1502 62.7188 49.1034 62.0156 51.0565 61.2344C56.6034 58.8125 57.619 57.0938 66.994 33.5781C68.4784 29.75 69.5721 26.4688 69.2596 26.2344C68.5565 25.5312 63.869 27.6406 61.5252 29.8281C58.7909 32.3281 56.994 35.7656 55.1971 42.0156C54.494 44.5938 53.4002 47.7188 52.8534 48.9688C51.9159 51.1562 51.8377 50.9219 50.9002 44.2812C48.7909 29.2031 48.244 26 47.5409 26C44.6502 26 36.7596 31.8594 36.7596 33.9688C36.7596 34.4375 36.2909 35.8438 35.6659 37.1719C35.0409 38.5781 33.6346 42.1719 32.4627 45.2969C31.2127 48.4219 29.9627 50.7656 29.6502 50.5312C29.2596 50.2969 28.9471 47.0156 28.9471 43.1875C28.9471 35.6875 28.244 32.875 25.5877 30.0625C24.1034 28.4219 19.5721 26 18.0877 26C17.7752 26 18.3221 30.6875 19.3377 36.3125Z",
    fill: "#4353FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebflow);
export default __webpack_public_path__ + "static/media/webflow.534f4833952a6cb849d0b93921ca90d2.svg";
export { ForwardRef as ReactComponent };